import React from 'react'
import BarBase, { BarProps, BarType } from './BarBase'
import './BarSuccess'

function BarSuccess(props: BarProps) {
  return (
   <BarBase {...props} type={BarType.Success} />
  )
}

export default BarSuccess
